import { Avatar } from "@mui/material";

export const COLUMNS = [
    {
        header: "AVATAR",
        accessor:"image",
        render: () => <Avatar
            src={"https://i.pravatar.cc/300"}
            sx={{
                height: "25%"
            }}
        />,
    },
    {
        header: "HR NAME",
        accessor: "firstName",
        render: (data: any) =>
            [data?.firstName, data?.lastName].filter(Boolean).join(" ") || "--",
    },
    {
        header: "Employee ID",
        accessor: "employeeId",
    },
    {
        header: "Email",
        accessor: "email",
    },
    {
        header: "Phone",
        accessor: "phone",
    },
    {
        header: "Corporate",
        accessor: "corporateId",
        render: (data: any) => data?.corporateName || data?.corporateId || "--",
    },

]
